module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/en/2-a897feda2ff4c7bf0515611f44a10171.jpg";